import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function GuaranteeSection() {
  return <section className="py-12 md:py-20 px-4 md:px-6 bg-navy" data-id="element-146">
      <div className="max-w-4xl mx-auto" data-id="element-147">
        <FadeIn data-id="element-148">
          <div className="bg-gradient-to-br from-navy-card to-navy-light rounded-2xl md:rounded-3xl p-8 md:p-14 text-center border-2 border-gold/25 relative overflow-hidden shadow-xl shadow-gold/5" data-id="element-149">
            {/* Subtle radial glow */}
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(255,215,0,0.08)_0%,transparent_60%)] pointer-events-none" data-id="element-150" />

            {/* Seal */}
            <div className="w-28 h-28 md:w-32 md:h-32 mx-auto mb-8 relative z-10" data-id="element-151">
              <div className="w-full h-full bg-gradient-to-br from-navy to-navy-mid rounded-full flex flex-col items-center justify-center border-4 border-gold shadow-[0_0_0_8px_rgba(255,215,0,0.15),0_8px_32px_rgba(10,22,40,0.2)] animate-[pulse_4s_ease-in-out_infinite]" data-id="element-152">
                <div className="font-serif text-4xl md:text-5xl font-black text-gold leading-none" data-id="element-153">
                  7
                </div>
                <div className="text-[10px] md:text-xs font-bold tracking-widest uppercase text-white/70 mt-1" data-id="element-154">
                  días garantía
                </div>
              </div>
            </div>

            <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-6 relative z-10" data-id="element-155">
              Tu inversión está 100% protegida
            </h2>

            <p className="text-base md:text-lg text-white/70 leading-relaxed max-w-2xl mx-auto relative z-10" data-id="element-156">
              Prueba la guía durante 7 días completos. Si aplicas los consejos y
              no notas una mejora real en el descanso de tu familia, te
              devolvemos el 100% de tu dinero. Sin preguntas, sin formularios
              complicados. Así de simple. El riesgo es completamente nuestro.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}